import { render, staticRenderFns } from "./BetSlipPriceInputs.vue?vue&type=template&id=32f55122&scoped=true"
import script from "./BetSlipPriceInputs.vue?vue&type=script&lang=js"
export * from "./BetSlipPriceInputs.vue?vue&type=script&lang=js"
import style0 from "./BetSlipPriceInputs.vue?vue&type=style&index=0&id=32f55122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f55122",
  null
  
)

export default component.exports